import { createRoot } from 'react-dom/client'

import { WidgetSelector } from 'omnicom/components/widgets/WidgetSelector'
import { lazyWidgets } from 'omnicom/constants/lazyWidgets'
import { CustomRoutes } from 'omnicom/routes/CustomRoutes'
import { omnicomRemoteReducers, omniProjectReducer } from 'omnicom/store'
import { AppLoaderWrapper } from 'src/AppLoaderWrapper'
import { App } from 'src/core/components/App'

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)

root.render(
  <App
    appStore={{ storeReducer: omniProjectReducer, remoteReducers: omnicomRemoteReducers }}
    AppWidgets={WidgetSelector}
    AppLazyWidgets={lazyWidgets}
    CustomRoutes={CustomRoutes}
    LoaderWrapper={AppLoaderWrapper}
  />
)
